module.exports = __webpack_public_path__ + "static/media/SintLub.65cd9c03.png";